// extracted by mini-css-extract-plugin
module.exports = {"root":"_8391a9ad87b610075240791088ec4e24-less"};